export function getBreadcrumbSchema(breadcrumbList) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    numberOfItems: breadcrumbList.length,
    itemListElement: breadcrumbList.map((el, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': `${process.env.NEXT_PUBLIC_BASE_URL}${el['as']}`,
          name: el.name,
          alternateName: el.name
        }
      }
    }),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${process.env.NEXT_PUBLIC_BASE_URL}${
        breadcrumbList[breadcrumbList.length - 1]['as']
      }`,
      url: `${process.env.NEXT_PUBLIC_BASE_URL}${breadcrumbList[breadcrumbList.length - 1]['as']}`
    }
  }
}
